import { useEffect, useRef } from 'react'
import moment from 'moment'

const Timer = ({ timeLeft, setTimeLeft }) => {
    const timeLeftRef = useRef(timeLeft)
    const formatTimeLeft = time => moment.utc(time).format('mm:ss')

    useEffect(() => {
        timeLeftRef.current = timeLeft
    }, [timeLeft])

    useEffect(() => {
        if (timeLeft <= 0) return

        const intervalId = setInterval(() => {
            setTimeLeft(prevTime => {
                const newTime = prevTime - 1000
                return newTime < 0 ? 0 : newTime
            })
        }, 1000)
        return () => clearInterval(intervalId)
    }, [setTimeLeft])

    return (
        <div className="text-center mt-3">
            {timeLeft === 0 ? (
                <T>pix.payment.code.expired</T>
            ) : (
                <span>
                    <T>pix.payment.timer.label</T> {formatTimeLeft(timeLeft)}
                </span>
            )}
        </div>
    )
}

export default Timer
